export default "__VITE_ASSET__xRckg_np__"